import { BAD_WEATHER, BOTH_GOOD_AND_BAD_WEATHER, GOOD_WEATHER, SurfaceEnum } from "../components/UserVisibleStrings";

export type ForecastTime = {
    date: string,
    hour: string,
};

export function convertForecastTimeToDate( forecastTime: ForecastTime )
{
    const forecastTimeStr = `${forecastTime.date.slice( 0, 4 )}-${forecastTime.date.slice( 4, 6 )}-${forecastTime.date.slice( 6, 8 )}T${forecastTime.hour}:00`;
    return new Date( forecastTimeStr );
}


export function getSurfaceEnumFromString( surfaceString: string ): SurfaceEnum | undefined
{
    switch ( surfaceString )
    {
        case SurfaceEnum.AGGREGATE:
        case GOOD_WEATHER:
        case BOTH_GOOD_AND_BAD_WEATHER:
        case BAD_WEATHER:
            return SurfaceEnum.AGGREGATE;
        case SurfaceEnum.TEMPERATURE: return SurfaceEnum.TEMPERATURE;
        case SurfaceEnum.WIND_SPEED: return SurfaceEnum.WIND_SPEED;
        case SurfaceEnum.WIND_GUST: return SurfaceEnum.WIND_GUST;
        case SurfaceEnum.VISIBILITY: return SurfaceEnum.VISIBILITY;
        case SurfaceEnum.THUNDERSTORM: return SurfaceEnum.THUNDERSTORM;
        case SurfaceEnum.SNOW: return SurfaceEnum.SNOW;
        case SurfaceEnum.ICE: return SurfaceEnum.ICE;
        case SurfaceEnum.RAIN: return SurfaceEnum.RAIN;
        default: return undefined;
    }
}
export function displayName( surfaceKey: string ): string
{
    if ( surfaceKey === "VISIBILITY" ) return "Visibility (3 days)";
    return (
        surfaceKey
            .toLowerCase()
            .split( "_" )
            .filter( each => each !== "apparent" )
            .map( word => word.charAt( 0 ).toUpperCase() + word.slice( 1 ) )
            .join( " " )
    );
}

export type ComponentTaus = {
    name: SurfaceEnum,
    taus: Array<number>,
    geojsonTaus: Array<number>,
};
export type AllForecastComponents = {
    impact: ForecastComponents,
    goldilocks: ForecastComponents,
};
export type ForecastComponents = {
    components: Array<ComponentTaus>,
    disabledComponentNames: Array<SurfaceEnum>,
};
